import { render, staticRenderFns } from "./LicAuth.vue?vue&type=template&id=bf6389de&scoped=true&"
import script from "./LicAuth.vue?vue&type=script&lang=js&"
export * from "./LicAuth.vue?vue&type=script&lang=js&"
import style0 from "./LicAuth.vue?vue&type=style&index=0&id=bf6389de&lang=css&scoped=true&"
import style1 from "./LicAuth.vue?vue&type=style&index=1&id=bf6389de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6389de",
  null
  
)

export default component.exports